module.exports = __webpack_public_path__ + "media/images/hitfun/icon.notification.active.pink-1805d97d64f133b80025d2398c47c1e7.svg";